import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MobileDeviceService } from '@app/services/mobile-device.service';
import { RecentSearchModel } from '@recent-searches/entities/recent-search';
import { getRecentSearches } from '@recent-searches/mappers/recent-searches.mapper';

@Pipe({
  name: 'recentSearches',
  standalone: false
})
export class RecentSearchesPipe implements PipeTransform {

  constructor(
    private readonly mobileDeviceService: MobileDeviceService
  ) { }

  private get isMobile$(): Observable<boolean> {
    return this.mobileDeviceService.isMobileDevice$;
  }

  transform(searches: RecentSearchModel[]): Observable<RecentSearchModel[]> {
    return this.isMobile$.pipe(
      map(isMobile => getRecentSearches(isMobile, searches))
    );
  }
}
